import { FormattedMessage } from 'react-intl';
import { Flex } from '@chakra-ui/react';

import SecondaryButton from '../utils/SecondaryButton';

import { ReactComponent as DownloadIcon } from '../../icons/download.svg';
import { downloadJobLog } from '../../services/studies';
import { downloadFile } from '../../services/items';

const DownloadButtonCell = ({ node, jobId }) => {
    const { logName, createdDate } = node.data;

    const downloadLog = async () => {
        const fileInfo = await downloadJobLog(jobId, logName, createdDate);
        downloadFile(fileInfo);
    };

    return (
        <Flex justifyContent="center" alignItems="center" w="100%">
            <SecondaryButton
                leftIcon={<DownloadIcon />}
                w="auto !important"
                size="sm"
                type="button"
                variant="secondary"
                onClick={downloadLog}
            >
                <FormattedMessage id="common_download_btn_tooltip_and_label" />
            </SecondaryButton>
        </Flex>
    );
};

export default DownloadButtonCell;
